import './firebase'
import {
  getAuth,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  getAdditionalUserInfo,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  signInAnonymously,
  linkWithPopup,
  updateProfile
} from 'firebase/auth'

export const auth = getAuth()
export const currentUser = auth.currentUser
// export const authData = auth().currentUser

// const provider = new auth.GoogleAuthProvider()

const provider = new GoogleAuthProvider();

export function signIn(credentials) {
  return new Promise((resolve, reject) => {
    signInWithEmailAndPassword(auth, credentials.email, credentials.password)
      .then(result => {
        const user = result.user;
        // const isFirstLogin = getAdditionalUserInfo(result)
        resolve(user)
      }).catch(error => {
        reject(error)
      });
  })
}

export function signInWithGoogle() {
  return new Promise((resolve, reject) => {
    signInWithPopup(auth, provider)
      .then(result => {
        const user = result.user;
        const isFirstLogin = getAdditionalUserInfo(result).isNewUser
        resolve({ user, isFirstLogin })
      }).catch(error => {
        reject(error)
      });
  })
}

export function linkWithGoogle() {
  return linkWithPopup(auth.currentUser, provider)
}

export function signInAnon() {
  return new Promise((resolve, reject) => {
    signInAnonymously(auth)
      .then(result => {
        const user = result.user;
        resolve(user)
      }).catch(error => {
        reject(error)
      });
  })
}

export function setupAuth(btnId) {
  console.log("yes?")
  // console.log(btnId)
  window.recaptchaVerifier = new RecaptchaVerifier(btnId, {
    'size': 'invisible',
    'callback': () => {
      console.log("callback called")
      phoneAuth()
    }
  }, auth)
  console.log(window.recaptchaVerifier)
}

export async function createPermanentAccount() {
  try {
    var result = await linkWithGoogle()
    return Promise.resolve({ user: result.user })
  } catch (error) {
    console.log(error)
    alert("You already have a previous account. Please Log in instead")
  }
  // const credential = GoogleAuthProvider.credential(user.getIdToken())
  // var { user } = await signInWithGoogle()
  // linkWithCredential(currentUser, credential)
  // .then((usercred) => {
  //   const user = usercred.user
  //   console.log(user)
  // }).catch(error => {
  //   console.log(error)
  // })
}

export function updateCurrentUserProfile(data) {
  return updateProfile(auth.currentUser, data)
}

function phoneAuth() {
  const appVerifier = window.recaptchaVerifier
  signInWithPhoneNumber(auth, '8638122677', appVerifier)
  .then((confirmationResult) => {
    console.log(confirmationResult)
  })
}

export function appSignOut() {
  return signOut(auth)
}

// export const authActions = { signIn, signInWithGoogle, signOut }
export const authActions = { signIn, appSignOut }